export const disabledSocials = ['vk', 'fb', 'ok', 'google', 'mailRuAccount', 'appleid', 'gosuslugi'];
